import type { CanvasElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../../registry/factoryShared';

export function createRectElement(config: BaseElementConfig): CanvasElement<'rect'> {
  return { ...createBase('rect', config), data: {} };
}
